module.exports = __webpack_public_path__ + "fonts/TBCSailec-Bold.ef5183cd.eot";